import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
const APP_BAR_HEIGHT = 68;

export const useAppBarHeight = () => {
  const location = useTryLocation();
  const [appBarHeight, setAppBarHeight] = useState(APP_BAR_HEIGHT);
  const [heightWithoutAppBar, setHeightWithoutAppBar] = useState(`calc(100vh - ${APP_BAR_HEIGHT}px)`);

  useLayoutEffect(() => {
    const appBar = document.getElementById('appbar');
    if (appBar) {
      setAppBarHeight(appBar.clientHeight + 1);
      setHeightWithoutAppBar(`calc(100vh - ${appBar.clientHeight}px)`);
    }
  }, [location]);

  return {
    appBarHeight,
    heightWithoutAppBar,
  };
};

// refresh calculation on location change, to handle jumbo appbar
const useTryLocation = () => {
  let location: ReturnType<typeof useLocation> | Location = window.location;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    location = useLocation();
  } catch {
    // do nothing
  }

  return location;
};
